// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__YA4eW","link":"Footer_link__ekh2r"};